import { render, staticRenderFns } from "./WeatherAgrometeorologyPage.vue?vue&type=template&id=0f8a12ff&"
import script from "./WeatherAgrometeorologyPage.vue?vue&type=script&lang=js&"
export * from "./WeatherAgrometeorologyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports